import styled, { css } from 'styled-components/macro';
import { ReactComponent as Warning } from '../assets/icons/warning.svg';

export const EmptyTableTd = styled.td`
  text-align: center;
  margin-top: 30px;
  padding-top: 50px;
  padding-bottom: 50px;
  && {
    border-bottom: none;
  }
`;

export const WarningSVG = styled(Warning)`
  /* margin-top: 120px; */
  width: 2.2rem;
  fill: ${props => props.theme.red};
  ${props =>
    props.styled.noMargin &&
    css`
      margin-top: 0;
    `}
`;

export const WarningTextH5 = styled.h5`
  text-transform: none;
  margin-top: 5px;
  color: ${props => props.theme.red};
  font-weight: 300;
`;

export const ErrorMessageDiv = styled.div`
  text-align: center;
  padding: 120px 0 50px;
`;

WarningSVG.defaultProps = {
  styled: {}
};

export const EmptyTableDiv = styled.div`
  padding-top: 2rem;
`;

export const EmptyTableH5 = styled.h5`
  color: ${props => props.theme.dustierGray};
  margin-bottom: 4px;
`;

export const EmptyTableImg = styled.img`
  height: ${props => props.theme.height}px;
  margin-bottom: 15px;
`;

export const EmptyTableP = styled.p`
  color: ${props => props.theme.dustyGray};
  max-width: 160px;
  margin: 0 auto;
  ${props =>
    props.styled.italic &&
    css`
      font-style: italic;
    `}
`;
EmptyTableP.defaultProps = { styled: {} };
